import { Box } from "@mui/material";
import React from "react";

export default function Wrapper({ children }) {
  return <Box sx={{ padding: "1rem" }}>{children}</Box>;
}
